class SessionData {
  currency: string;

  affiliate: string | null;

  tenant?: string | null;
  // TODO add more props... (auth, lang, ...)
}

export default SessionData;
